import BILLING_API from 'api/billing/v1'
import { startSubmit, stopSubmit, SubmissionError } from 'redux-form'
import { call, put, takeLatest } from 'redux-saga/effects'
import extractErrors from 'utils/extractErrors'
import { notificationShow } from 'modules/Notifications/actions'

function* submitAutoReplenishSettings({
  payload: { accountId, data, formName },
  meta: { resolve = () => {}, reject = () => {} } = {},
}) {
  try {
    yield put(startSubmit(formName))

    const { error } = yield call(BILLING_API.submitAutoReplenishSettings, {
      accountId,
      data,
    })

    if (error) {
      throw error
    }

    yield put(
      notificationShow({
        type: 'success',
        message: `autoreplenish::form.notifications.${
          data.is_auto_replenishment_active ? 'enabled' : 'disabled'
        }`,
      }),
    )

    resolve()
  } catch (error) {
    const { form, fields } = extractErrors(error.errors)

    reject(fields ? new SubmissionError(fields) : error.statusText)

    if (form) {
      yield put(
        notificationShow({
          type: 'error',
          message: form,
          delay: 10000,
        }),
      )
    }
  } finally {
    yield put(stopSubmit(formName))
  }
}

export default function* Sagas() {
  yield takeLatest('AUTOREPLENISH/SUBMIT_SETTINGS', submitAutoReplenishSettings)
}
